import React, { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

// Approximate India's boundaries (can be adjusted as needed)
const INDIA_BOUNDS = L.latLngBounds(
  [6.0, 68.0],  // Southwest
  [36.0, 98.0]   // Northeast
);

const MaskLayer = ({ selectedState, selectedDistrict, stateData, selectedVillage, mapService }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    // 1. First prevent tile loading outside India
    const originalGetTileUrl = L.GridLayer.prototype.getTileUrl;
    
    L.GridLayer.include({
      getTileUrl: function(coords) {
        // Convert tile coordinates to geographic bounds
        const tileSize = this.getTileSize();
        const nwPoint = coords.scaleBy(tileSize);
        const sePoint = nwPoint.add(tileSize);
        const nw = map.unproject(nwPoint, coords.z);
        const se = map.unproject(sePoint, coords.z);
        const tileBounds = L.latLngBounds(nw, se);
        
        // Only load tiles that intersect with India's bounds
        if (!INDIA_BOUNDS.intersects(tileBounds)) {
          return null; // Skip loading this tile
        }
        
        return originalGetTileUrl.call(this, coords);
      }
    });

    // 2. Apply your existing mask logic
    const maskLayer = L.layerGroup().addTo(map);
    const outerBounds = [
      [90, -180], [90, 180], [-90, 180], [-90, -180], [90, -180]
    ];

    let maskPolygons = [outerBounds];

    const addMask = (geometry) => {
      if (!geometry) return;
      const geoJsonLayer = L.geoJSON(geometry);
      geoJsonLayer.eachLayer((layer) => {
        const latlngs = layer.getLatLngs();
        if (latlngs.length > 0) maskPolygons.push(latlngs);
      });
    };

    if (selectedVillage) {
      addMask(selectedVillage.geometry);
    } else if (selectedDistrict) {
      addMask(selectedDistrict.geometry);
    } else if (selectedState) {
      addMask(selectedState.geometry);
    } else if (stateData) {
      L.geoJSON(stateData).eachLayer((layer) => {
        const latlngs = layer.getLatLngs();
        if (latlngs.length > 0) maskPolygons.push(latlngs);
      });
    }

    L.polygon(maskPolygons, {
      color: "white",
      weight: 1,
      fillOpacity: .5,
      zIndex: 50
    }).addTo(maskLayer);

    // 3. Set initial view to India if no selection
    if (!selectedState && !selectedDistrict && !selectedVillage) {
      map.fitBounds(INDIA_BOUNDS);
    }

    return () => {
      map.removeLayer(maskLayer);
      // Restore original getTileUrl method
      L.GridLayer.prototype.getTileUrl = originalGetTileUrl;
    };
  }, [selectedState, selectedDistrict, stateData, selectedVillage, mapService, map]);

  return null;
};

export default MaskLayer;